import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import Async, { useAsync } from "react-select/async";
import DatePicker from "react-datepicker";
import "../myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../../baseurl";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { GetIp } from "../../../Forms/ShortCutComponents/Get_ip";
import ResponseLoader from "../../../Forms/ShortCutComponents/ResponseLoader";
import ImageContaboUpload from "../../../Forms/ShortCutComponents/ImageContaboUpload";
import { checkPermission } from "../../../../Helper";

export default function ItemForm(props) {
  let defaultdate = new Date();
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");
  var companyName = localStorage.getItem("companyName");
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalText, setModalText] = useState("");
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [requiredLovs, setRequiredLovs] = useState(false);
  const [checkModuleType, setcheckModuleType] = useState(false);
  const [checkClientPriorType, setcheckClientPriorType] = useState(false);
  const [selectedOption, setSelectedOption] = useState("option1");
  const [priority, setpriority] = useState("prior1");
  const [attachmentEnable, setAttachmentEnable] = useState(true);
  const [masterId, setMasterId] = useState(null);
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState();
  const [fileAttachments, setFileAttachments] = useState([]);

  const handleFileKeyChange = (fileKeys) => {
    let processedFiles = [];
    if (Array.isArray(fileKeys)) {
      processedFiles = fileKeys.filter(
        (key) => key !== null && key !== undefined && key !== ""
      );
    } else if (fileKeys) {
      processedFiles = [fileKeys];
    }
    setFileAttachments(processedFiles);
  };

  const prior = [
    { id: 1, label: "High", value: "1" },
    { id: 2, label: "Medium", value: "2" },
    { id: 3, label: "Low", value: "3" },
  ];
  const [data, setData] = useState({
    ticket_no: "",
    ticketType: "",
    cntctPers: "",
    startDate: new Date(),
    modType: "",
    userIp: "",
    shortDesc: "",
    clientPrior: "",
    companyName: companyName,
    accPrior: "",
    username: username,
    details: "",
    disabled: false,
    crDate: new Date(),
    status: "",
    showModalAddNew: true,
    activity: props?.propData?.location?.rowData?.referencePk,
  });
  const getUserIp = async function () {
    let res = await GetIp();
    setData({
      ...data,
      userIp: res.ip,
      userCountry: res.country,
    });
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };

  const toggleAddNew = (showModalAddNew) => {
    setData({ ...data, [showModalAddNew]: showModalAddNew });
    props.toggle();
  };
  const inputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    if (
      name === "defaultRateShow" &&
      value === "1" &&
      Number(data.defaultRate) <= 0
    ) {
      swal({
        title: "Default rate should be more than 0",
        text: 'Default rate should be more than 0 when display rate on invoice is "Yes" ',
        icon: "warning",
      });
      setData({
        ...data,
        defaultRate: 1,
        [name]: value,
      });
    } else {
      setData({
        ...data,
        [name]: value,
      });
    }
  };
  const selectTicketTypeEvent = (...waiterTypeField) => {
    if (waiterTypeField && requiredLovs === false) {
      setRequiredLovs(false);
    } else {
      setRequiredLovs(true);
    }
    setData({
      ...data,
      ticketType: waiterTypeField[0],
    });
  };
  const selectModTypeEvent = (...modTypeField) => {
    if (modTypeField && requiredLovs === false) {
      setcheckModuleType(false);
    } else {
      setcheckModuleType(true);
    }
    setData({
      ...data,
      modType: modTypeField[0],
    });
  };
  const handleSendToAccmen = () => {
    axios
      .post(
        `${baseurl}/Support/getSendSuppTicket`,
        {
          Id: masterId,
          username: username,
          companyId: companyId,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        setAttachmentEnable(false);
        let addresponse = response.data;
        setLoadingResponce(false);
        if (response.data.duplicate === true) {
          swal({
            title: "Duplicate Code is not Allowed",
            text: "Duplicate Entry",
            icon: "error",
          });
        } else {
          // toggleAddNew();

          swal({
            title: "Ticket Generated!",
            text: "Ticket Has Been Generated and Sent To Accmen",
            icon: "success",
          }).then((value) => {
            setShowModal(false);
            toggleAddNew();
          });

          setData({
            ...data,
            ticket_no: addresponse.ticket_no,
            disabled: true,
          });
        }
      })
      .catch(function (error) {
        console.log("erooor", error);
        setLoadingResponce(false);
        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
      });

    // After the logic is executed, you can close the modal.
  };

  const handleDraft = () => {
    // Your logic to handle the "Cancel" button click here...
    // For example, you might want to reset some form fields.

    // Close the modal.
    setShowModal(false);
    toggleAddNew();
  };
  const selectClientPriorEvent = (...clientPriorField) => {
    if (clientPriorField && requiredLovs === false) {
      setcheckClientPriorType(false);
    } else {
      setcheckClientPriorType(true);
    }
    setData({
      ...data,
      clientPrior: clientPriorField[0],
    });
  };
  const selectAccPriorEvent = (...accPriorField) => {
    setData({
      ...data,
      accPrior: accPriorField[0],
    });
  };

  const [getDataModType, setGetDataModType] = useState([]);
  const [getDataTickType, setGetDataTickType] = useState([]);
  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
      if (openModalCheck) {
        toggleAddNew();
        return;
      }
    };

    if (props.EditData > -1) {
      // funCall(2);
      getWithId();
    } else {
      // funCall(1);
      getUserIp();
    }
    getModType();
    getTicketType();
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/AddTicketForm";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  const getWithId = () => {
    let resData;
    let tableId = props.EditData;
    axios
      .post(
        `${baseurl}/Support/getSuppTicketById`,
        { id: tableId, companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        setAttachmentEnable(false);
        resData = res.data.data[0];
        let ticket_id = resData["ticket_id"];
        let ticket_no = resData["ticket_no"];
        let crDate = new Date(resData["ticket_dt"]);
        let ticketType = resData["ticket_type_id"];
        let ticket_type_desc = resData["ticket_type_desc"];
        let userIp = resData["ip"];
        let username = resData["created_by"];
        let cntctPers = resData["contact_person"];
        let modType = resData["module_id"];
        let mod_desc = resData["module_desc"];
        let shortDesc = resData["short_desc"];
        let imageId = resData["attach_url"];
        let ridAddress = resData["attach_desc"];
        let clientPriorId = resData["Priority_client"];
        let details = resData["ticket_detail"];
        let clientPriorRefill = prior.filter(
          (repType) => repType.id == clientPriorId
        );
        setMasterId(ticket_id);
        // Load existing Contabo attachment key(s) from attach_url (stored as a
        // JSON array string). Normalize to an array so state stays consistent.
        let parsedAttach = [];
        if (imageId) {
          try {
            const parsed = JSON.parse(imageId);
            parsedAttach = Array.isArray(parsed) ? parsed : [imageId];
          } catch (e) {
            parsedAttach = [imageId];
          }
        }
        setFileAttachments(parsedAttach);

        let clientPriorObj = {
          id: clientPriorRefill[0]?.id,
          label: clientPriorRefill[0]?.label,
        };
        ticketType = {
          id: ticketType,
          label: ticket_type_desc,
        };
        modType = {
          id: modType,
          label: mod_desc,
        };
        setData({
          ...data,
          modType,
          ridAddress,
          ticketType,
          clientPrior: clientPriorObj,
          ticket_no,
          crDate,
          ticketType,
          userIp,
          username,
          cntctPers,
          modType,
          shortDesc,
          clientPrior: clientPriorObj,
          details,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getTicketType = () => {
    axios
      .post(
        `${baseurl}/lovs/getTicketType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(async (response) => {
        let ticketdata = [];
        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          ticketdata.push({
            id: responseData[loop]?.ticket_type_id,
            label: `${responseData[loop]?.ticket_type_desc}`,
            value: `${responseData[loop]?.ticket_type_id}`,
          });
        }
        setGetDataTickType({
          ...getDataTickType,
          tickTypeOptions: ticketdata,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getModType = () => {
    axios
      .post(
        `${baseurl}/lovs/getModType`,
        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        let responseData = response.data.data;
        let modTypedata = [];
        for (let loop = 0; loop < responseData.length; loop++) {
          let element = responseData[loop];
          modTypedata.push({
            id: responseData[loop]?.module_id,
            value: responseData[loop]?.module_desc,
            label: `${responseData[loop]?.module_desc}`,
            isDisabled: false,
          });
          if (
            element.ref_link_det?.length == 0 ||
            element.ref_link_det == null
          ) {
            modTypedata[loop].isDisabled = true;
          } else {
            modTypedata[loop].isDisabled = false;
          }
        }
        setGetDataModType({
          ...getDataModType,
          modTypeOptions: modTypedata,
        });
        // setShowModal(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        backgroundColor: isDisabled
          ? "#00569e"
          : isSelected
          ? "#c8ced3"
          : isFocused
          ? "#c8ced3"
          : "white",
        color: isDisabled ? "#ffffff" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
        position: "relative",
        paddingLeft:
          data.styleLevel == 2 ? "22px" : data.styleLevel == 3 ? "37px" : "",
        wordBreak: "break-all",
        borderBottom: "1px solid #f7ebeb",
      };
    },
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    setFile(event.target.files[0]);
    console.log("file----", file);
    setImageUrl(URL.createObjectURL(file));
  };

  const handleSendFile = async (masterId) => {
    console.log("file :>> ", file);
    setLoadingResponce(true);
    let { userIp, userCountry } = await getUserIp();

    const formData = new FormData();
    formData.append("files", file);
    formData.append("username", username);
    formData.append("companyId", companyId);
    formData.append("userIp", userIp);
    formData.append("userCountry", userCountry);
    formData.append("masterId", masterId);
    formData.append("ridAddress", data.ridAddress);

    axios
      .post(`${baseurl}/Support/addFile`, formData, {
        headers: {
          authorization: token,
        },
      })
      .then(function (response) {
        setAttachmentEnable(true);
        setLoadingResponce(false);
        console.log("response====>", response.data.id);

        const string = "https://drive.google.com/uc?export=view&id=";
        const id = response.data.id;
        const imageUrl = string + id;
        console.log("ID: ", id);
        console.log("imageUrl: ", imageUrl);
        setImageUrl(imageUrl);
        // swal({
        //   title: "Picture Uploaded!",
        //   text: "Your Picture is uploaded",
        //   icon: "success",
        // });
        setModalTitle("Ticket Generated!");
        setModalText(
          "Sending to Accmen will help you get your query resolved sooner"
        );
        setShowModal(true);
        setData({
          ...data,
          // ticket_no: addresponse.ticket_no,
          disabled: true,
        });
      })
      .catch(function (error) {
        console.log("erooor", error);
        swal({
          title: "Error!",
          text: "Your Picture is not uploaded",
          icon: "success",
        });
        // setLoadingResponce(false);
      });
  };

  const handleSubmitAddItem = async (event) => {
    event.preventDefault();
    setLoadingResponce(true);

    var companyId = localStorage.getItem("companyId");
    const { ticketType, modType, clientPrior } = data;

    if (ticketType?.id && modType?.id && clientPrior?.id) {
      if (props.EditData > -1) {
        let Id = props.EditData;
        axios
          .post(
            `${baseurl}/Support/getUpdateSuppTicket`,
            {
              Id,
              companyId,
              username: data.username,
              ticketType: data.ticketType.id,
              cntctPers: data.cntctPers,
              modType: data.modType.id,
              shortDesc: data.shortDesc,
              details: data.details,
              clientPrior: data.clientPrior.id,
              attachment_file: JSON.stringify(fileAttachments),
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Success!",
                text: "Ticket Updated!",
                icon: "success",
              }).then((value) => {
                setData({
                  ...data,
                  disabled: true,
                });
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            setLoadingResponce(false);
            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      } else {
        let { userIp, userCountry } = await getUserIp();
        axios
          .post(
            `${baseurl}/Support/getAddSuppTicket`,
            {
              userCountry,
              companyId,
              companyName,
              ticket_no: data.ticket_no,
              // crDate: data.crDate.moment().format("YYYY-MM-DD"),
              crDate: moment(data.crDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
              startDate: data.startDate,
              ticketType: data.ticketType.id,
              userIp,
              username: username,
              cntctPers: data.cntctPers,
              modType: data.modType.id,
              shortDesc: data.shortDesc,
              details: data.details,
              clientPrior: data.clientPrior.id,
              accPrior: data.accPrior.id,
              attachment_file: JSON.stringify(fileAttachments),
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            const id = response.data.ticket_no;
            setMasterId(id);
            console.log("id", id);
            setAttachmentEnable(false);
            let addresponse = response.data;
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              // toggleAddNew();
              swal({
                title: "Draft Ticket!",
                text: "Ticket Generated As Draft",
                icon: "success",
              });
              // .then((value) => {
              // });

              setData({
                ...data,
                ticket_no: addresponse.ticket_no,
                disabled: true,
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setLoadingResponce(false);
            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      }
    } else {
      setLoadingResponce(false);
      swal({
        title: "Required Fields",
        text: "Please select all * required fields.",
        icon: "warning",
      });
      setRequiredLovs(true);
    }
  };
  return (
    <>
      <Modal
        show={showModal}
        size="md"
        style={{ marginTop: "10%" }}
        onHide={setShowModal}
      >
        <Modal.Header
          closeButton
          id="modalHeader"
          className="Creative-Invoice-header-styling p-3"
        >
          <strong>
            <h4>What To Do Next</h4>
          </strong>
        </Modal.Header>

        <Modal.Body>
          <div className="custom-modal">
            <div className="custom-modal-content">
              <div className="custom-modal-buttons">
                <h2>{modalTitle}</h2>
                <p>{modalText}</p>
                <Button
                  style={{ margin: "3px" }}
                  type="submit"
                  size="sm"
                  color="warning"
                  onClick={handleDraft}
                >
                  Keep Draft
                </Button>
                <Button
                  style={{ margin: "3px" }}
                  type="submit"
                  size="sm"
                  color="success"
                  onClick={handleSendToAccmen}
                >
                  Send To Accmen
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {loadingResponce ? (
        <ResponseLoader />
      ) : (
        <div>
          <Modal
            show={data.showModalAddNew}
            size="xl"
            onHide={toggleAddNew}
            backdrop="static"
          >
            <Modal.Header
              closeButton
              onClick={toggleAddNew}
              className=" Creative-Invoice-header-styling"
            >
              <strong>
                <h4> {props.EditData > -1 ? "Update" : "Add"} Ticket </h4>
              </strong>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <div className="row">
                    <div className="col-md-12">
                      <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                        <div className="row">
                          <div
                            className="col-md-2"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Ticket NO# :
                            </Label>
                            <Input
                              value={data.ticket_no}
                              onChange={inputEvent}
                              required
                              name="ticket_no"
                              id="ticket_no"
                              isClearable
                              placeholder="NEW"
                              disabled
                            />
                          </div>
                          <div
                            className="col-md-3"
                            style={{
                              marginBottom: "12px",
                              marginLeft: "20px",
                            }}
                          >
                            <Label style={{ fontWeight: "bold" }}>Date :</Label>
                            <DatePicker
                              className="form-control "
                              wrapperClassName="datePicker"
                              selected={data?.crDate}
                              id="invoice_date"
                              name="invoice_date"
                              disabled
                              dateFormat="MMMM d, yyyy h:mm aa"
                              required
                            />
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "12px", marginLeft: "20px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>Time :</Label>
                            <DatePicker
                              className="form-control "
                              wrapperClassName="datePicker"
                              selected={data.crDate}
                              id="invoice_date"
                              name="invoice_date"
                              timeInputLabel="Time:"
                              dateFormat="h:mm aa"
                              showTimeInput
                              required
                              disabled
                            />
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "12px", marginLeft: "20px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Ticket Type : {data?.disabled}
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                            <Select
                              value={data.ticketType}
                              onChange={selectTicketTypeEvent}
                              options={getDataTickType.tickTypeOptions}
                              required
                              isDisabled={data?.disabled}
                              isClearable
                              name="ticketType"
                            />
                            {requiredLovs && !data.ticketType?.id ? (
                              <>
                                <h7
                                  style={{
                                    color: "red",
                                    fontSize: "75%",
                                  }}
                                >
                                  Ticket Type is required!
                                </h7>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          {/* <div
                            className="col-md-3"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              User Ip :
                            </Label>
                            <Input
                              value={data.userIp}
                              onChange={inputEvent}
                              required
                              name="userIp"
                              id="userIp"
                              disabled
                            />
                          </div> */}
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              User Name :
                            </Label>
                            <Input
                              value={data.username}
                              onChange={inputEvent}
                              required
                              name="username"
                              id="username"
                              isClearable
                              disabled
                            />
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Company:
                            </Label>
                            <Input
                              value={data.companyName}
                              onChange={inputEvent}
                              required
                              name="companyName"
                              id="companyName"
                              isClearable
                              disabled
                            />
                          </div>
                          <div
                            className="col-md-3"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Contact Person :
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                            <Input
                              value={data.cntctPers}
                              onChange={inputEvent}
                              required
                              name="cntctPers"
                              id="cntctPers"
                              isClearable
                              disabled={data?.disabled}
                            />
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Module : {data?.disabled}
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                            <Select
                              value={data.modType}
                              onChange={selectModTypeEvent}
                              options={getDataModType.modTypeOptions}
                              required
                              isClearable
                              styles={customStyles}
                              name="Module"
                              isDisabled={data?.disabled}
                            />
                            {requiredLovs && !data.modType?.id ? (
                              <>
                                <h7
                                  style={{
                                    color: "red",
                                    fontSize: "75%",
                                  }}
                                >
                                  Module is required!
                                </h7>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Client Priority :
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                            <Select
                              value={data.clientPrior}
                              onChange={selectClientPriorEvent}
                              options={prior}
                              required
                              isDisabled={data?.disabled}
                              isClearable
                              name="clientPriority"
                            />
                            {requiredLovs && !data.clientPrior?.id ? (
                              <>
                                <h7
                                  style={{
                                    color: "red",
                                    fontSize: "75%",
                                  }}
                                >
                                  Priority is required!
                                </h7>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Short Description :
                              {/* <h8 style={{ color: "tomato" }}>*</h8> */}
                            </Label>
                            <Input
                              value={data.shortDesc}
                              onChange={inputEvent}
                              // required
                              name="shortDesc"
                              id="shortDesc"
                              disabled={data?.disabled}
                              isClearable
                            />
                          </div>{" "}
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Details :<h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                            <Input
                              type="textarea"
                              value={data.details}
                              onChange={inputEvent}
                              required
                              name="details"
                              id="details"
                              disabled={data?.disabled}
                              isClearable
                            />
                          </div>
                          {/* <div
                            className="col-md-6"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Accmen Priority :
                              <h8 style={{ color: "tomato" }}>*</h8>
                            </Label>
                            <Select
                              value={data.accPrior}
                              onChange={selectAccPriorEvent}
                              options={prior}
                              required
                              isClearable
                              placeholder="Accmen Priority"
                            />
                          </div> */}
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <hr
                              style={{
                                border: "1px solid ",
                                marginBottom: "-2px",
                                marginTop: "3vh",
                                borderColor: "E4E5E6",
                              }}
                            />
                          </div>
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <ImageContaboUpload
                              isDisabled={data?.disabled}
                              toggleAddNew={handleFileKeyChange}
                              existingFileKey={fileAttachments}
                              entryId={masterId}
                              isViewMode={data?.disabled}
                              companyName={companyName}
                              moduleType="support_tickets"
                            />
                          </div>
                        </div>
                        <hr
                          style={{
                            border: "2px solid ",
                            marginBottom: "3vh",
                            marginTop: "3vh",
                            borderColor: "E4E5E6",
                          }}
                        />
                        <FormGroup>
                          <Button
                            disabled={data?.disabled}
                            type="submit"
                            className="mr-1 invoiceSubmitButton "
                          >
                            {props.EditData > -1 ? "Update" : "Save"} Changes
                          </Button>

                          <Button
                            onClick={() => toggleAddNew()}
                            type="button"
                            className="mr-1"
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </FormGroup>
                      </Form>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}
